import { TabModules } from '~/data/company';
import { EmployeeModuleConfig } from '~/scenes/PortalViews/Views/EmployeeViews/Modules/types';

export enum EmployeeModuleTabPath_Rewarding {
  General = 'general',
  Incentives = 'incentives',
  BillableHours = 'billable-hours',
  Benefits = 'benefits',
  Acknowledgements = 'acknowledgements',
  BankAccount = 'bank-account',
  Documents = 'documents',
  CustomData = 'custom-data',
  Summary = 'summary',
  WorkTime = 'worktime',
}

export enum EmployeeModuleTabConfigKey_Rewarding {
  Acknowledgements = 'REW_ACKNOWLEDGEMENTS',
  BankAccount = 'REW_BANK_ACCOUNT',
  Benefits = 'REW_BENEFITS',
  BillableHours = 'REW_BILLABLE_HOURS',
  CustomData = 'REW_CUSTOM_DATA',
  Documents = 'REW_DOCUMENTS',
  General = 'REW_GENERAL',
  Incentives = 'REW_INCENTIVES',
  Summary = 'REW_SUMMARY',
  WorkTime = 'REW_TIME_REPORTING',
}

export enum EmployeeModuleTabInstructionKey_Rewarding {
  Acknowledgements = 'INSTRUCTIONS_REW_ACKNOWLEDGEMENTS',
  BankAccount = 'INSTRUCTIONS_REW_BANK_ACCOUNT_TAB',
  Benefits = 'INSTRUCTIONS_REW_BENEFITS',
  BillableHours = 'INSTRUCTIONS_REW_BILLABLE_HOURS',
  CustomData = 'INSTRUCTIONS_REW_CUSTOM_DATA',
  Documents = 'INSTRUCTIONS_REW_DOCUMENTS',
  General = 'INSTRUCTIONS_REW_GENERAL',
  Incentives = 'INSTRUCTIONS_REW_INCENTIVES',
  Summary = 'INSTRUCTIONS_REW_SUMMARY',
  WorkTime = 'INSTRUCTIONS_REW_WORK_TIME',
}

export const EmployeeModuleRouting_Rewarding: EmployeeModuleConfig<
  EmployeeModuleTabPath_Rewarding,
  EmployeeModuleTabConfigKey_Rewarding,
  EmployeeModuleTabInstructionKey_Rewarding
> = {
  path: 'rewarding',
  module: TabModules.REWARDING,
  defaultTab: EmployeeModuleTabPath_Rewarding.General,
  tabConfigs: [
    {
      path: EmployeeModuleTabPath_Rewarding.General,
      enabledConfigKey: EmployeeModuleTabConfigKey_Rewarding.General,
      instructionKey: EmployeeModuleTabInstructionKey_Rewarding.General,
    },
    {
      path: EmployeeModuleTabPath_Rewarding.Incentives,
      enabledConfigKey: EmployeeModuleTabConfigKey_Rewarding.Incentives,
      instructionKey: EmployeeModuleTabInstructionKey_Rewarding.Incentives,
    },
    {
      path: EmployeeModuleTabPath_Rewarding.BillableHours,
      enabledConfigKey: EmployeeModuleTabConfigKey_Rewarding.BillableHours,
      instructionKey: EmployeeModuleTabInstructionKey_Rewarding.BillableHours,
    },
    {
      path: EmployeeModuleTabPath_Rewarding.Benefits,
      enabledConfigKey: EmployeeModuleTabConfigKey_Rewarding.Benefits,
      instructionKey: EmployeeModuleTabInstructionKey_Rewarding.Benefits,
    },
    {
      path: EmployeeModuleTabPath_Rewarding.Acknowledgements,
      enabledConfigKey: EmployeeModuleTabConfigKey_Rewarding.Acknowledgements,
      instructionKey:
        EmployeeModuleTabInstructionKey_Rewarding.Acknowledgements,
    },
    {
      path: EmployeeModuleTabPath_Rewarding.BankAccount,
      enabledConfigKey: EmployeeModuleTabConfigKey_Rewarding.BankAccount,
      instructionKey: EmployeeModuleTabInstructionKey_Rewarding.BankAccount,
    },
    {
      path: EmployeeModuleTabPath_Rewarding.Documents,
      enabledConfigKey: EmployeeModuleTabConfigKey_Rewarding.Documents,
      instructionKey: EmployeeModuleTabInstructionKey_Rewarding.Documents,
    },
    {
      path: EmployeeModuleTabPath_Rewarding.CustomData,
      enabledConfigKey: EmployeeModuleTabConfigKey_Rewarding.CustomData,
      instructionKey: EmployeeModuleTabInstructionKey_Rewarding.CustomData,
    },
    {
      path: EmployeeModuleTabPath_Rewarding.Summary,
      enabledConfigKey: EmployeeModuleTabConfigKey_Rewarding.Summary,
      instructionKey: EmployeeModuleTabInstructionKey_Rewarding.Summary,
    },
    {
      path: EmployeeModuleTabPath_Rewarding.WorkTime,
      enabledConfigKey: EmployeeModuleTabConfigKey_Rewarding.WorkTime,
      instructionKey: EmployeeModuleTabInstructionKey_Rewarding.WorkTime,
    },
  ],
};
